export function checkSales_addProductAndSubsProduct(product:any, subProductArray:any) {    
  //console.log('hello checkSales_addProductAndSubsProduct');
    let enable_return = true;  
    let barcodes = new Array();
    if(product.manysize){//manysize = true
      let field_main = [['brand','string'], ['tax', 'number'], ['vat_reduction','number'], ['id_category','string'], ['img','string'], ['manysize','boolean'], ['name','string'], ['type','number'], ['position','string'], ['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean']];
      for(const p in product){
        
        let check_duplicate = false;
        if(p.indexOf('webapp_') === -1){
          for(const q in field_main){
            if(p === field_main[q][0]){
              check_duplicate = true;
              if(typeof product[p] != field_main[q][1]){
                console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào product', p);
                if(enable_return) return true;
              }
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào product', p);
          if(enable_return) return true;
        }
        
      } 
      for(const p in field_main){
        let check_duplicate = false;
        for(const q in product){
          if(field_main[p][0] === q){
            check_duplicate = true;
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào product', p);
          if(enable_return) return true;
        }
      } 
      
      for(let i=0; i<subProductArray.length; i++){            
        let field_sub = [['manylot','boolean'], ['name','string'], ['selling','boolean'], ['units','object'], ['warning_number','number'], ['item_code','string'], ['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean']];
        if(subProductArray[i].manylot){
          field_sub = [['manylot','boolean'], ['name','string'], ['selling','boolean'], ['units','object'], ['warning_number','number'], ['item_code','string'],
                      ['days_exp_warning','number'], ['days_import_warning','number'], ['lots','object'], ['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean']];
        }else{
            for(const p in subProductArray[i]){
              let check_duplicate = false;
              if(p.indexOf('webapp_') === -1){
                for(const q in field_sub){
                  if(p === field_sub[q][0]){
                    check_duplicate = true;
                    if(typeof subProductArray[i][p] != field_sub[q][1]){
                      console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào subProductArray', p);
                      if(enable_return) return true;
                    }
                  }
                }
              }
              if(!check_duplicate){
                console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào subProductArray', p);
                if(enable_return) return true;
              }              
            } 
            for(const p in field_sub){
              let check_duplicate = false;
              for(const q in subProductArray[i]){
                if(field_sub[p][0] === q){
                  check_duplicate = true;
                }
              }
              if(!check_duplicate){
                console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào subProductArray', p);
                if(enable_return) return true;
              }              
            } 
            if(subProductArray[i].units){
              for(let j=0; j<subProductArray[i].units.length; j++){
                let field_unit = [['barcode','string'], ['default','boolean'], ['price','number'], ['price2','number'], ['price_import','number'], ['ratio','number'], 
                                  ['unit','string']];
                for(const p in subProductArray[i].units[j]){
                  let check_duplicate = false;
                  if(p.indexOf('webapp_') === -1){
                    for(const q in field_unit){
                      if(p === field_unit[q][0]){
                        check_duplicate = true;
                        if(typeof subProductArray[i].units[j][p] != field_unit[q][1]){
                          console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào subProductArray(units)', p);
                          if(enable_return) return true;
                        }
                      }
                    }
                  }
                  if(!check_duplicate){
                    console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào subProductArray(units)', p);
                    if(enable_return) return true;
                  }                               
                } 
                if(subProductArray[i].units[j]['barcode'] != "") barcodes.push(subProductArray[i].units[j]['barcode']);    
                for(const p in field_unit){
                  let check_duplicate = false;
                  for(const q in subProductArray[i].units[j]){
                    if(field_unit[p][0] === q){
                      check_duplicate = true;
                    }
                  }
                  if(!check_duplicate){
                    console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào subProductArray(units)', p);
                    if(enable_return) return true;
                  }
                } 
              }
            }
            if(subProductArray[i].lots){
              for(let j=0; j<subProductArray[i].lots.length; j++){
                let field_lot = [['barcode','string'], ['date_exp','object'], ['date_mfg','object'], ['hidden','boolean'], ['lot_number','string']];
                for(const p in subProductArray[i].lots[j]){
                  let check_duplicate = false;
                  if(p.indexOf('webapp_') === -1){
                    for(const q in field_lot){
                      if(p === field_lot[q][0]){
                        check_duplicate = true;
                        if(typeof subProductArray[i].lots[j][p] != field_lot[q][1]){
                          console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào subProductArray(lots)', p);
                          if(enable_return) return true;
                        }
                      }
                    }
                  }
                  if(!check_duplicate){
                    console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào subProductArray(lots)', p);
                    if(enable_return) return true;
                  }                  
                } 
                if(subProductArray[i].lots[j]['barcode'] != "") barcodes.push(subProductArray[i].lots[j]['barcode']);
                for(const p in field_lot){
                  let check_duplicate = false;
                  for(const q in subProductArray[i].lots[j]){
                    if(field_lot[p][0] === q){
                      check_duplicate = true;
                    }
                  }
                  if(!check_duplicate){
                    console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào subProductArray(lots)', p);
                    if(enable_return) return true;
                  }
                } 
              }
            }
        }
      }
      
    }else{//manysize = false        
      let field_main = [['brand','string'], ['tax', 'number'], ['vat_reduction','number'], ['id_category','string'], ['img','string'], ['manylot','boolean'], ['manysize','boolean'], ['position','string'],
                        ['name','string'], ['selling','boolean'], ['type','number'], ['units','object'], ['warning_number','number'], ['item_code','string'], ['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean']];
      if(product.manylot){
        field_main = [['brand','string'], ['tax', 'number'], ['vat_reduction','number'], ['id_category','string'], ['img','string'], ['manylot','boolean'], ['manysize','boolean'], ['position','string'],
                      ['name','string'], ['selling','boolean'], ['type','number'], ['units','object'], ['warning_number','number'], ['item_code','string'], ['days_exp_warning','number'], ['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean'],
                      ['days_import_warning','number'], ['lots','object']];
      }
      for(const p in product){           
        let check_duplicate = false;
        if(p.indexOf('webapp_') === -1){
          for(const q in field_main){            
            if(p === field_main[q][0]){
              check_duplicate = true;                
              if(typeof product[p] != field_main[q][1]){
                console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào product', p);
                return false;
              }
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào product', p);
          if(enable_return) return true;
        }          
      } 
      for(const p in field_main){
        let check_duplicate = false;
        for(const q in product){
          if(field_main[p][0] === q){
            check_duplicate = true;
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào product', p);
          if(enable_return) return true;
        }          
      } 
      if(product.units){
        for(let j=0; j<product.units.length; j++){
          let field_unit = [['barcode','string'], ['default','boolean'], ['price','number'], ['price2','number'], ['price_import','number'], ['ratio','number'], ['unit','string']];
          for(const p in product.units[j]){
            let check_duplicate = false;
            if(p.indexOf('webapp_') === -1){
              for(const q in field_unit){
                if(p === field_unit[q][0]){
                  check_duplicate = true;
                  if(typeof product.units[j][p] != field_unit[q][1]){
                    console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào product(units)', p);
                    if(enable_return) return true;
                  }
                }
              }
            }
            if(!check_duplicate){
              console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào product(units)', p);
              if(enable_return) return true;
            }              
          } 
          if(product.units[j]['barcode'] != "") barcodes.push(product.units[j]['barcode']);
          for(const p in field_unit){
            let check_duplicate = false;
            for(const q in product.units[j]){
              if(field_unit[p][0] === q){
                check_duplicate = true;
              }
            }
            if(!check_duplicate){
              console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào product(units)', p);
              if(enable_return) return true;
            }
          } 
        }
      }
      if(product.lots){
        for(let j=0; j<product.lots.length; j++){
          let field_lot = [['barcode','string'], ['date_exp','object'], ['date_mfg','object'], ['hidden','boolean'], ['lot_number','string']];
          for(const p in product.lots[j]){
            let check_duplicate = false;
            if(p.indexOf('webapp_') === -1){
              for(const q in field_lot){
                if(p === field_lot[q][0]){
                  check_duplicate = true;
                  if(typeof product.lots[j][p] != field_lot[q][1]){
                    console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào product(lots)', p);
                    if(enable_return) return true;
                  }
                }
              }
            }
            if(!check_duplicate){
              console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào product(lots)', p);
              if(enable_return) return true;
            }              
          } 
          if(product.lots[j]['barcode'] != "") barcodes.push(product.lots[j]['barcode']);
          for(const p in field_lot){
            let check_duplicate = false;
            for(const q in product.lots[j]){
              if(field_lot[p][0] === q){
                check_duplicate = true;
              }
            }
            if(!check_duplicate){
              console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào product(lots)', p);
              if(enable_return) return true;
            }
          } 
        }
      }   
    }
    
    for(let i=0; i<barcodes.length-1; i++){        
      for(let j=i+1; j<barcodes.length; j++){          
        if(barcodes[i] === barcodes[j]) {
          console.log('Vui lòng kiểm tra, bị trùng barcode');
          if(enable_return) return true;
        }
      }
    }  
    return false;
}

export function checkSales_addSubProduct(id_product:string, subProduct:any){    
  let enable_return = true; 
  if(!id_product || id_product ==='') {
    console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào id_product');
    if(enable_return) return true;
  }
  let barcodes = new Array();
  let field_sub = [['manylot','boolean'], ['name','string'], ['selling','boolean'], ['units','object'], ['warning_number','number'], ['item_code','string'], ['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean']];
  if(subProduct.manylot){
    field_sub = [['manylot','boolean'], ['name','string'], ['selling','boolean'], ['units','object'], ['warning_number','number'], ['item_code','string'],
                ['days_exp_warning','number'], ['days_import_warning','number'], ['lots','object'], ['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean']];
  }else{
      for(const p in subProduct){
        let check_duplicate = false;
        for(const q in field_sub){
          if(p === field_sub[q][0]){
            check_duplicate = true;
            if(typeof subProduct[p] != field_sub[q][1]){
              console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào subProduct', p);
              if(enable_return) return true;
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào subProduct', p);
          if(enable_return) return true;
        }              
      } 
      for(const p in field_sub){
        let check_duplicate = false;
        for(const q in subProduct){
          if(field_sub[p][0] === q){
            check_duplicate = true;
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào subProduct', p);
          if(enable_return) return true;
        }              
      } 
      if(subProduct.units){
        for(let j=0; j<subProduct.units.length; j++){
          let field_unit = [['barcode','string'], ['default','boolean'], ['price','number'], ['price2','number'], ['price_import','number'], ['ratio','number'], 
                            ['unit','string']];
          for(const p in subProduct.units[j]){
            let check_duplicate = false;
            for(const q in field_unit){
              if(p === field_unit[q][0]){
                check_duplicate = true;
                if(typeof subProduct.units[j][p] != field_unit[q][1]){
                  console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào subProduct(units)', p);
                  if(enable_return) return true;
                }
              }
            }
            if(!check_duplicate){
              console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào subProduct(units)', p);
              if(enable_return) return true;
            }                               
          } 
          if(subProduct.units[j]['barcode'] != "") barcodes.push(subProduct.units[j]['barcode']);    
          for(const p in field_unit){
            let check_duplicate = false;
            for(const q in subProduct.units[j]){
              if(field_unit[p][0] === q){
                check_duplicate = true;
              }
            }
            if(!check_duplicate){
              console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào subProduct(units)', p);
              if(enable_return) return true;
            }
          } 
        }
      }
      if(subProduct.lots){
        for(let j=0; j<subProduct.lots.length; j++){
          let field_lot = [['barcode','string'], ['date_exp','object'], ['date_mfg','object'], ['hidden','boolean'], ['lot_number','string']];
          for(const p in subProduct.lots[j]){
            let check_duplicate = false;
            for(const q in field_lot){
              if(p === field_lot[q][0]){
                check_duplicate = true;
                if(typeof subProduct.lots[j][p] != field_lot[q][1]){
                  console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào subProduct(lots)', p);
                  if(enable_return) return true;
                }
              }
            }
            if(!check_duplicate){
              console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào subProduct(lots)', p);
              if(enable_return) return true;
            }                  
          } 
          if(subProduct.lots[j]['barcode'] != "") barcodes.push(subProduct.lots[j]['barcode']);
          for(const p in field_lot){
            let check_duplicate = false;
            for(const q in subProduct.lots[j]){
              if(field_lot[p][0] === q){
                check_duplicate = true;
              }
            }
            if(!check_duplicate){
              console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào subProduct(lots)', p);
              if(enable_return) return true;
            }
          } 
        }
      }
  }  
  return false;
}

export function checkSales_updateSubProduct(id_subproduct:string, value:any){    
  let enable_return = true; 
  if(!id_subproduct || id_subproduct ==='') {
    console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào id_subproduct');
    if(enable_return) return true;
  }

  let barcodes = new Array();  
  let field_sub = [['manylot','boolean'], ['name','string'], ['selling','boolean'], ['units','object'], ['warning_number','number'], ['item_code','string'],
                   ['days_exp_warning','number'], ['days_import_warning','number'], ['lots','object'], ['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean']];
  
  for(const p in value){
    let check_duplicate = false;
    for(const q in field_sub){
      if(p === field_sub[q][0]){
        check_duplicate = true;
        if(typeof value[p] != field_sub[q][1]){
          console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value', p);
          if(enable_return) return true;
        }
      }
    }
    if(!check_duplicate){
      console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value', p);
      if(enable_return) return true;
    }              
  } 
  
  if(value.units){
    for(let j=0; j<value.units.length; j++){
      let field_unit = [['barcode','string'], ['default','boolean'], ['price','number'], ['price2','number'], ['price_import','number'], ['ratio','number'], 
                        ['unit','string']];
      for(const p in value.units[j]){
        let check_duplicate = false;
        for(const q in field_unit){
          if(p === field_unit[q][0]){
            check_duplicate = true;
            if(typeof value.units[j][p] != field_unit[q][1]){
              console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value(units)', p);
              if(enable_return) return true;
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value(units)', p);
          if(enable_return) return true;
        }                               
      } 
      if(value.units[j]['barcode'] != "") barcodes.push(value.units[j]['barcode']);    
      for(const p in field_unit){
        let check_duplicate = false;
        for(const q in value.units[j]){
          if(field_unit[p][0]===q){
            check_duplicate = true;           
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào value(units)', p);
          if(enable_return) return true;
        }                               
      } 
      
    }
  }
  if(value.lots){
    for(let j=0; j<value.lots.length; j++){
      let field_lot = [['_id','string'], ['barcode','string'], ['date_exp','object'], ['date_mfg','object'], ['hidden','boolean'], ['lot_number','string']];
      for(const p in value.lots[j]){
        let check_duplicate = false;
        for(const q in field_lot){
          if(p === field_lot[q][0]){
            check_duplicate = true;
            if(typeof value.lots[j][p] != field_lot[q][1]){
              console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value(lots)', p);
              if(enable_return) return true;
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value(lots)', p);
          if(enable_return) return true;
        }                  
      } 
      if(value.lots[j]['barcode'] != "") barcodes.push(value.lots[j]['barcode']);      
      for(const p in field_lot){
        let check_duplicate = false;
        for(const q in value.lots[j]){
          if(field_lot[p][0] === q){
            check_duplicate = true;            
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào value(lots)', p);
          if(enable_return) return true;
        }                  
      } 

    }
  } 
  return false;
}

export function checkSales_updateProduct_Type3(id_product:string, value:any){   
  let enable_return = true;  
  if(!id_product || id_product ==='') {
    console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào id_product');
    if(enable_return) return true;
  }
  let barcodes = new Array();  
  let field_main = [['brand','string'], ['tax', 'number'], ['vat_reduction','number'], ['id_category','string'], ['img','string'], ['manylot','boolean'], ['manysize','boolean'],
                    ['name','string'], ['selling','boolean'], ['type','number'], ['units','object'], ['warning_number','number'], ['item_code','string'], ['days_exp_warning','number'], 
                    ['days_import_warning','number'], ['lots','object'], ['position','string'],['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean'],
                    ['id_design_barcode', 'string'], ['id_design_barcode_lot', 'string'], ['number_column', 'number'], ['number_column_lot', 'number'], ['number_print', 'number'], ['number_print_lot', 'number']];//sau này sẽ group phần designs này lại
  
  for(const p in value){
    let check_duplicate = false;
    for(const q in field_main){
      if(p === field_main[q][0]){
        check_duplicate = true;
        if(typeof value[p] != field_main[q][1]){
          console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value', p);
          if(enable_return) return true;
        }
      }
    }
    if(!check_duplicate){      
      console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value', p);
      if(enable_return) return true;           
    }              
  } 
  
  if(value.units){
    //console.log('----value', value)
    for(let j=0; j<value.units.length; j++){
      let field_unit = [['barcode','string'], ['default','boolean'], ['price','number'], ['price2','number'], ['price_import','number'], ['ratio','number'], 
                        ['unit','string']];
      for(const p in value.units[j]){
        let check_duplicate = false;
        for(const q in field_unit){
          if(p === field_unit[q][0]){
            check_duplicate = true;
            if(typeof value.units[j][p] != field_unit[q][1]){
              console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value(units)', p);
              if(enable_return) return true;
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value(units)', p);
          if(enable_return) return true;
        }                               
      } 
      if(value.units[j]['barcode'] != "") barcodes.push(value.units[j]['barcode']);   
      for(const p in field_unit){
        let check_duplicate = false;
        for(const q in value.units[j]){
          if(field_unit[p][0] === q){           
            check_duplicate = true;
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào value(units)', p);
          if(enable_return) return true;
        }
      }       
    }
  }
  if(value.lots){
    for(let j=0; j<value.lots.length; j++){
      let field_lot = [['_id','string'], ['barcode','string'], ['date_exp','object'], ['date_mfg','object'], ['hidden','boolean'], ['lot_number','string']];
      for(const p in value.lots[j]){
        let check_duplicate = false;
        for(const q in field_lot){
          if(p === field_lot[q][0]){
            check_duplicate = true;
            if(typeof value.lots[j][p] != field_lot[q][1]){
              console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value(lots)', p);
              if(enable_return) return true;
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value(lots)', p);
          if(enable_return) return true;
        }                  
      } 
      if(value.lots[j]['barcode'] != "") barcodes.push(value.lots[j]['barcode']);    
      for(const p in field_lot){
        let check_duplicate = false;
        for(const q in value.lots[j]){
          if(field_lot[p][0] === q){
            check_duplicate = true;            
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào value(lots)', p);
          if(enable_return) return true;
        }                  
      }       
    }
  } 
  return false;
}

export function checkSales_updateProduct_Type3_fw(id_product:string, value:any){  
  //console.log('--value', value); 
  let enable_return = true;  
  if(!id_product || id_product ==='') {
    console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào id_product');
    if(enable_return) return true;
  }
  let barcodes = new Array();  
  let field_main = [['brand','string'], ['tax', 'number'], ['vat_reduction','number'], ['id_category','string'], ['img','string'], ['manylot','boolean'], ['manysize','boolean'],
                    ['name','string'], ['selling','boolean'], ['type','number'], ['units','object'], ['warning_number','number'], ['item_code','string'], ['days_exp_warning','number'], 
                    ['quantity','number'], ['quantity_branch','object'],['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean'],
                    ['days_import_warning','number'], ['lots','object'], ['position','string'],
                    ['id_design_barcode', 'string'], ['id_design_barcode_lot', 'string'], ['number_column', 'number'], ['number_column_lot', 'number'], ['number_print', 'number'], ['number_print_lot', 'number']];//sau này sẽ group phần designs này lại
  
  for(const p in value){
    let check_duplicate = false;
    for(const q in field_main){
      if(p === field_main[q][0]){
        check_duplicate = true;
        if(typeof value[p] != field_main[q][1]){
          console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value', p);
          if(enable_return) return true;
        }
      }
    }
    if(!check_duplicate){
      if(value[p]['inventory'] === undefined){
        console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value', p);
        if(enable_return) return true;
      }      
    }              
  } 
  
  if(value.units){
    //console.log('----value', value)
    for(let j=0; j<value.units.length; j++){
      let field_unit = [['barcode','string'], ['default','boolean'], ['price','number'], ['price2','number'], ['price_import','number'], ['ratio','number'], 
                        ['unit','string']];
      for(const p in value.units[j]){
        let check_duplicate = false;
        for(const q in field_unit){
          if(p === field_unit[q][0]){
            check_duplicate = true;
            if(typeof value.units[j][p] != field_unit[q][1]){
              console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value(units)', p);
              if(enable_return) return true;
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value(units)', p);
          if(enable_return) return true;
        }                               
      } 
      if(value.units[j]['barcode'] != "") barcodes.push(value.units[j]['barcode']);   
      for(const p in field_unit){
        let check_duplicate = false;
        for(const q in value.units[j]){
          if(field_unit[p][0] === q){           
            check_duplicate = true;
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào value(units)', p);
          if(enable_return) return true;
        }
      }       
    }
  }
  if(value.lots){
    for(let j=0; j<value.lots.length; j++){
      let field_lot = [['_id','string'], ['barcode','string'], ['date_exp','object'], ['date_mfg','object'], ['hidden','boolean'], ['lot_number','string'], ['quantity','number'], ['quantity_branch','object']];
      for(const p in value.lots[j]){
        let check_duplicate = false;
        for(const q in field_lot){
          if(p === field_lot[q][0]){
            check_duplicate = true;
            if((p === 'date_exp')||(p === 'date_mfg')){
              value.lots[j][p] = new Date(value.lots[j][p]);
            }
            if(typeof value.lots[j][p] != field_lot[q][1]){
              console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value(lots)', p);
              if(enable_return) return true;
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value(lots)', p);
          if(enable_return) return true;
        }                  
      } 
      if(value.lots[j]['barcode'] != "") barcodes.push(value.lots[j]['barcode']);    
      for(const p in field_lot){
        let check_duplicate = false;
        for(const q in value.lots[j]){
          if(field_lot[p][0] === q){
            check_duplicate = true;            
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào value(lots)', p);
          if(enable_return) return true;
        }                  
      }       
    }
  } 
  return false;
}

export function checkSales_updateProduct_Type2(id_product:string, value:any){   
  let enable_return = true;  
  if(!id_product || id_product ==='') {
    console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào id_product');
    if(enable_return) return true;
  }
  let barcodes = new Array();  
  let field_main = [['brand','string'], ['tax', 'number'], ['vat_reduction','number'], ['id_category','string'], ['img','string'], ['manylot','boolean'], ['manysize','boolean'],
                    ['name','string'], ['selling','boolean'], ['type','number'], ['units','object'], ['warning_number','number'], ['item_code','string'], ['days_exp_warning','number'], 
                    ['days_import_warning','number'], ['lots','object'],['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean'],
                    ['id_design_barcode', 'string'], ['id_design_barcode_lot', 'string'], ['number_column', 'number'], ['number_column_lot', 'number'], ['number_print', 'number'], ['number_print_lot', 'number']];//sau này sẽ group phần designs này lại
  
  for(const p in value){
    let check_duplicate = false;
    for(const q in field_main){
      if(p === field_main[q][0]){
        check_duplicate = true;
        if(typeof value[p] != field_main[q][1]){
          console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value', p);
          if(enable_return) return true;
        }
      }
    }
    if(!check_duplicate){
      console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value', p);
      if(enable_return) return true;
    }              
  } 
  
  if(value.units){
    //console.log('----value', value)
    for(let j=0; j<value.units.length; j++){
      let field_unit = [['barcode','string'], ['default','boolean'], ['price','number'], ['price2','number'], ['ratio','number'], 
                        ['unit','string']];
      for(const p in value.units[j]){
        let check_duplicate = false;
        for(const q in field_unit){
          if(p === field_unit[q][0]){
            check_duplicate = true;
            if(typeof value.units[j][p] != field_unit[q][1]){
              console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value(units)', p);
              if(enable_return) return true;
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value(units)', p);
          if(enable_return) return true;
        }                               
      } 
      if(value.units[j]['barcode'] != "") barcodes.push(value.units[j]['barcode']);   
      for(const p in field_unit){
        let check_duplicate = false;
        for(const q in value.units[j]){
          if(field_unit[p][0] === q){           
            check_duplicate = true;
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào value(units)', p);
          if(enable_return) return true;
        }
      }       
    }
  }
  if(value.lots){
    for(let j=0; j<value.lots.length; j++){
      let field_lot = [['_id','string'], ['barcode','string'], ['date_exp','object'], ['date_mfg','object'], ['hidden','boolean'], ['lot_number','string']];
      for(const p in value.lots[j]){
        let check_duplicate = false;
        for(const q in field_lot){
          if(p === field_lot[q][0]){
            check_duplicate = true;
            if(typeof value.lots[j][p] != field_lot[q][1]){
              console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value(lots)', p);
              if(enable_return) return true;
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value(lots)', p);
          if(enable_return) return true;
        }                  
      } 
      if(value.lots[j]['barcode'] != "") barcodes.push(value.lots[j]['barcode']);    
      for(const p in field_lot){
        let check_duplicate = false;
        for(const q in value.lots[j]){
          if(field_lot[p][0] === q){
            check_duplicate = true;            
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào value(lots)', p);
          if(enable_return) return true;
        }                  
      }       
    }
  } 
  return false;
}
export function checkSales_updateProduct_Type5(id_product:string, value:any){   
  let enable_return = true;  
  if(!id_product || id_product ==='') {
    console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào id_product');
    if(enable_return) return true;
  }
  let barcodes = new Array();  
  let field_main = [['brand','string'], ['tax', 'number'], ['vat_reduction','number'], ['id_category','string'], ['img','string'], ['manylot','boolean'], ['manysize','boolean'],
                    ['name','string'], ['selling','boolean'], ['type','number'], ['units','object'], ['warning_number','number'], ['item_code','string'], ['days_exp_warning','number'], 
                    ['days_import_warning','number'], ['lots','object'], ['describe','string'],['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean'],
                    ['id_design_barcode', 'string'], ['id_design_barcode_lot', 'string'], ['number_column', 'number'], ['number_column_lot', 'number'], ['number_print', 'number'], ['number_print_lot', 'number']];//sau này sẽ group phần designs này lại
  
  for(const p in value){
    let check_duplicate = false;
    for(const q in field_main){
      if(p === field_main[q][0]){
        check_duplicate = true;
        if(typeof value[p] != field_main[q][1]){
          console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value', p);
          if(enable_return) return true;
        }
      }
    }
    if(!check_duplicate){
      console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value', p);
      if(enable_return) return true;
    }              
  } 
  
  if(value.units){    
    for(let j=0; j<value.units.length; j++){
      let field_unit = [['barcode','string'], ['default','boolean'], ['price','number'], ['ratio','number'], ['unit','string']];
      for(const p in value.units[j]){
        let check_duplicate = false;
        for(const q in field_unit){
          if(p === field_unit[q][0]){
            check_duplicate = true;
            if(typeof value.units[j][p] != field_unit[q][1]){
              console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value(units)', p);
              if(enable_return) return true;
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value(units)', p);
          if(enable_return) return true;
        }                               
      } 
      if(value.units[j]['barcode'] != "") barcodes.push(value.units[j]['barcode']);   
      for(const p in field_unit){
        let check_duplicate = false;
        for(const q in value.units[j]){
          if(field_unit[p][0] === q){            
            check_duplicate = true;
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào value(units)', p);
          if(enable_return) return true;
        }
      }       
    }
  }
  if(value.lots){
    for(let j=0; j<value.lots.length; j++){
      let field_lot = [['_id','string'], ['barcode','string'], ['date_exp','object'], ['date_mfg','object'], ['hidden','boolean'], ['lot_number','string']];
      for(const p in value.lots[j]){
        let check_duplicate = false;
        for(const q in field_lot){
          if(p === field_lot[q][0]){
            check_duplicate = true;
            if(typeof value.lots[j][p] != field_lot[q][1]){
              console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value(lots)', p);
              if(enable_return) return true;
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value(lots)', p);
          if(enable_return) return true;
        }                  
      } 
      if(value.lots[j]['barcode'] != "") barcodes.push(value.lots[j]['barcode']);    
      for(const p in field_lot){
        let check_duplicate = false;
        for(const q in value.lots[j]){
          if(field_lot[p][0] === q){
            check_duplicate = true;            
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào value(lots)', p);
          if(enable_return) return true;
        }                  
      }       
    }
  } 
  return false;
}

export function checkCafe_addProductAndSubsProduct_type1(product:any, subProductArray:any) {//type1 ko có lot    
    //console.log('hello checkSales_addProductAndSubsProduct');
    //delete product.price2;
    //delete product.unit;
    let enable_return = true;  
    let barcodes = new Array();
    if(product.manysize){//manysize = true
      let field_main = [['vat_reduction','number'], ['id_category','string'], ['img','string'], ['manysize','boolean'], ['name','string'], ['type','number'],
                        ['properties','object'], ['toppings','object'], ['time_warning','number'], ['describe','string'], ['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean']];           

      for(const p in product){        
        let check_duplicate = false;
        if(p.indexOf('webapp_') === -1){
          for(const q in field_main){
            if(p === field_main[q][0]){
              check_duplicate = true;
              if(typeof product[p] != field_main[q][1]){
                console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào product', p);
                if(enable_return) return true;
              }
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào product', p);
          if(enable_return) return true;
        }
        
      } 
      for(const p in field_main){
        let check_duplicate = false;
        for(const q in product){
          if(field_main[p][0] === q){
            check_duplicate = true;
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào product', field_main[p][0]);
          if(enable_return) return true;
        }
      } 
      
      for(let i=0; i<subProductArray.length; i++){            
        let field_sub = [['name','string'], ['selling','boolean'], ['units','object'], ['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean']];                
        for(const p in subProductArray[i]){
          let check_duplicate = false;
          if(p.indexOf('webapp_') === -1){
            for(const q in field_sub){
              if(p === field_sub[q][0]){
                check_duplicate = true;
                if(typeof subProductArray[i][p] != field_sub[q][1]){
                  console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào subProductArray', p);
                  if(enable_return) return true;
                }
              }
            }
          }
          if(!check_duplicate){
            console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào subProductArray', p);
            if(enable_return) return true;
          }              
        } 
        for(const p in field_sub){
          let check_duplicate = false;
          for(const q in subProductArray[i]){
            if(field_sub[p][0] === q){
              check_duplicate = true;
            }
          }
          if(!check_duplicate){
            console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào subProductArray',field_sub[p][0]);
            if(enable_return) return true;
          }              
        } 
        if(subProductArray[i].units){
          for(let j=0; j<subProductArray[i].units.length; j++){
            let field_unit = [['barcode','string'], ['default','boolean'], ['price','number'], ['price2','number'], ['ratio','number'], 
                              ['unit','string']];
            for(const p in subProductArray[i].units[j]){
              let check_duplicate = false;
              if(p.indexOf('webapp_') === -1){
                for(const q in field_unit){
                  if(p === field_unit[q][0]){
                    check_duplicate = true;
                    if(typeof subProductArray[i].units[j][p] != field_unit[q][1]){
                      console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào subProductArray(units)', p);
                      if(enable_return) return true;
                    }
                  }
                }
              }
              if(!check_duplicate){
                console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào subProductArray(units)', p);
                if(enable_return) return true;
              }                               
            } 
            if(subProductArray[i].units[j]['barcode'] != "") barcodes.push(subProductArray[i].units[j]['barcode']);    
            for(const p in field_unit){
              let check_duplicate = false;
              for(const q in subProductArray[i].units[j]){
                if(field_unit[p][0] === q){
                  check_duplicate = true;
                }
              }
              if(!check_duplicate){
                console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào subProductArray(units)', field_unit[p][0]);
                if(enable_return) return true;
              }
            } 
          }
        }              
      }      
    }else{//manysize = false           
      let field_main = [['vat_reduction','number'], ['id_category','string'], ['img','string'], ['manysize','boolean'], ['name','string'], ['type','number'], 
                        ['properties','object'], ['toppings','object'], ['time_warning','number'], ['describe','string'],
                        ['selling','boolean'], ['units','object'],['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean']];
      for(const p in product){          
        let check_duplicate = false;
        if(p.indexOf('webapp_') === -1){
          for(const q in field_main){            
            if(p === field_main[q][0]){
              check_duplicate = true;                
              if(typeof product[p] != field_main[q][1]){
                console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào product', p);
                return false;
              }
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào product', p);
          if(enable_return) return true;
        }          
      } 
      for(const p in field_main){
        let check_duplicate = false;
        for(const q in product){
          if(field_main[p][0] === q){
            check_duplicate = true;
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào product', field_main[p][0]);
          if(enable_return) return true;
        }          
      } 
      if(product.units){
        for(let j=0; j<product.units.length; j++){
          let field_unit = [['barcode','string'], ['default','boolean'], ['price','number'], ['price2','number'], ['ratio','number'], ['unit','string']];
          for(const p in product.units[j]){
            let check_duplicate = false;
            if(p.indexOf('webapp_') === -1){
              for(const q in field_unit){
                if(p === field_unit[q][0]){
                  check_duplicate = true;
                  if(typeof product.units[j][p] != field_unit[q][1]){
                    console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào product(units)', p);
                    if(enable_return) return true;
                  }
                }
              }
            }
            if(!check_duplicate){
              console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào product(units)', p);
              if(enable_return) return true;
            }              
          } 
          if(product.units[j]['barcode'] != "") barcodes.push(product.units[j]['barcode']);
          for(const p in field_unit){
            let check_duplicate = false;
            for(const q in product.units[j]){
              if(field_unit[p][0] === q){
                check_duplicate = true;
              }
            }
            if(!check_duplicate){
              console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào product(units)', field_unit[p][0]);
              if(enable_return) return true;
            }
          } 
        }
      }       
    }    
    for(let i=0; i<barcodes.length-1; i++){        
      for(let j=i+1; j<barcodes.length; j++){          
        if(barcodes[i] === barcodes[j]) {
          console.log('Vui lòng kiểm tra, bị trùng barcode');
          if(enable_return) return true;
        }
      }
    }  
    return false;
}

export function checkCafe_addProductAndSubsProduct_type3(product:any, subProductArray:any) {    
  //console.log('hello checkSales_addProductAndSubsProduct');
    delete product.price2;
    let enable_return = true;  
    let barcodes = new Array();
    if(product.manysize){//manysize = true
      let field_main = [['brand','string'], ['tax', 'number'], ['vat_reduction','number'], ['id_category','string'], ['img','string'], ['manysize','boolean'], ['name','string'], ['type','number'], ['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean']];        
      for(const p in product){        
        let check_duplicate = false;
        if(p.indexOf('webapp_') === -1){
          for(const q in field_main){
            if(p === field_main[q][0]){
              check_duplicate = true;
              if(typeof product[p] != field_main[q][1]){
                console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào product', p);
                if(enable_return) return true;
              }
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào product', p);
          if(enable_return) return true;
        }
        
      } 
      for(const p in field_main){
        let check_duplicate = false;
        for(const q in product){
          if(field_main[p][0] === q){
            check_duplicate = true;
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào product', field_main[p][0]);
          if(enable_return) return true;
        }
      } 
      
      for(let i=0; i<subProductArray.length; i++){            
        let field_sub = [['manylot','boolean'], ['name','string'], ['selling','boolean'], ['units','object'], ['warning_number','number'], ['item_code','string'], ['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean']];
        if(subProductArray[i].manylot){
          field_sub = [['manylot','boolean'], ['name','string'], ['selling','boolean'], ['units','object'], ['warning_number','number'], ['item_code','string'], ['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean'],
                      ['days_exp_warning','number'], ['days_import_warning','number'], ['lots','object']];
        }
        for(const p in subProductArray[i]){
          let check_duplicate = false;
          if(p.indexOf('webapp_') === -1){
            for(const q in field_sub){
              if(p === field_sub[q][0]){
                check_duplicate = true;
                if(typeof subProductArray[i][p] != field_sub[q][1]){
                  console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào subProductArray', p);
                  if(enable_return) return true;
                }
              }
            }
          }
          if(!check_duplicate){
            console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào subProductArray', p);
            if(enable_return) return true;
          }              
        } 
        for(const p in field_sub){
          let check_duplicate = false;
          for(const q in subProductArray[i]){
            if(field_sub[p][0] === q){
              check_duplicate = true;
            }
          }
          if(!check_duplicate){
            console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào subProductArray', field_sub[p][0]);
            if(enable_return) return true;
          }              
        } 
        if(subProductArray[i].units){
          for(let j=0; j<subProductArray[i].units.length; j++){
            let field_unit = [['barcode','string'], ['default','boolean'], ['price','number'], ['price2','number'], ['price_import','number'], ['ratio','number'], 
                              ['unit','string']];
            for(const p in subProductArray[i].units[j]){
              let check_duplicate = false;
              if(p.indexOf('webapp_') === -1){
                for(const q in field_unit){
                  if(p === field_unit[q][0]){
                    check_duplicate = true;
                    if(typeof subProductArray[i].units[j][p] != field_unit[q][1]){
                      console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào subProductArray(units)', p);
                      if(enable_return) return true;
                    }
                  }
                }
              }
              if(!check_duplicate){
                console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào subProductArray(units)', p);
                if(enable_return) return true;
              }                               
            } 
            if(subProductArray[i].units[j]['barcode'] != "") barcodes.push(subProductArray[i].units[j]['barcode']);    
            for(const p in field_unit){
              let check_duplicate = false;
              for(const q in subProductArray[i].units[j]){
                if(field_unit[p][0] === q){
                  check_duplicate = true;
                }
              }
              if(!check_duplicate){
                console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào subProductArray(units)', p);
                if(enable_return) return true;
              }
            } 
          }
        }
        if(subProductArray[i].lots){
          for(let j=0; j<subProductArray[i].lots.length; j++){
            let field_lot = [['barcode','string'], ['date_exp','object'], ['date_mfg','object'], ['hidden','boolean'], ['lot_number','string']];
            for(const p in subProductArray[i].lots[j]){
              let check_duplicate = false;
              if(p.indexOf('webapp_') === -1){
                for(const q in field_lot){
                  if(p === field_lot[q][0]){
                    check_duplicate = true;
                    if(typeof subProductArray[i].lots[j][p] != field_lot[q][1]){
                      console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào subProductArray(lots)', p);
                      if(enable_return) return true;
                    }
                  }
                }
              }
              if(!check_duplicate){
                console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào subProductArray(lots)', p);
                if(enable_return) return true;
              }                  
            } 
            if(subProductArray[i].lots[j]['barcode'] != "") barcodes.push(subProductArray[i].lots[j]['barcode']);
            for(const p in field_lot){
              let check_duplicate = false;
              for(const q in subProductArray[i].lots[j]){
                if(field_lot[p][0] === q){
                  check_duplicate = true;
                }
              }
              if(!check_duplicate){
                console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào subProductArray(lots)', p);
                if(enable_return) return true;
              }
            } 
          }
        }        
      }
      
    }else{//manysize = false        
      let field_main = [['brand','string'], ['tax', 'number'], ['vat_reduction','number'], ['id_category','string'], ['img','string'], ['manylot','boolean'], ['manysize','boolean'], 
                        ['name','string'], ['selling','boolean'], ['type','number'], ['units','object'], ['warning_number','number'], ['item_code','string'], ['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean']];
      if(product.manylot){
        field_main = [['brand','string'], ['tax', 'number'], ['vat_reduction','number'], ['id_category','string'], ['img','string'], ['manylot','boolean'], ['manysize','boolean'],
                      ['name','string'], ['selling','boolean'], ['type','number'], ['units','object'], ['warning_number','number'], ['item_code','string'], ['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean'],
                      ['days_exp_warning','number'], ['days_import_warning','number'], ['lots','object']];
      }
      for(const p in product){          
        let check_duplicate = false;
        if(p.indexOf('webapp_') === -1){
          for(const q in field_main){            
            if(p === field_main[q][0]){
              check_duplicate = true;                
              if(typeof product[p] != field_main[q][1]){
                console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào product', p);
                return false;
              }
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào product', p);
          if(enable_return) return true;
        }          
      } 
      for(const p in field_main){
        let check_duplicate = false;
        for(const q in product){
          if(field_main[p][0] === q){
            check_duplicate = true;
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào product', field_main[p][0]);
          if(enable_return) return true;
        }          
      } 
      if(product.units){
        for(let j=0; j<product.units.length; j++){
          let field_unit = [['barcode','string'], ['default','boolean'], ['price','number'], ['price2','number'], ['price_import','number'], ['ratio','number'], ['unit','string']];
          for(const p in product.units[j]){
            let check_duplicate = false;
            if(p.indexOf('webapp_') === -1){
              for(const q in field_unit){
                if(p === field_unit[q][0]){
                  check_duplicate = true;
                  if(typeof product.units[j][p] != field_unit[q][1]){
                    console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào product(units)', p);
                    if(enable_return) return true;
                  }
                }
              }
            }
            if(!check_duplicate){
              console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào product(units)', p);
              if(enable_return) return true;
            }              
          } 
          if(product.units[j]['barcode'] != "") barcodes.push(product.units[j]['barcode']);
          for(const p in field_unit){
            let check_duplicate = false;
            for(const q in product.units[j]){
              if(field_unit[p][0] === q){
                check_duplicate = true;
              }
            }
            if(!check_duplicate){
              console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào product(units)', field_unit[p][0]);
              if(enable_return) return true;
            }
          } 
        }
      }
      if(product.lots){
        for(let j=0; j<product.lots.length; j++){
          let field_lot = [['barcode','string'], ['date_exp','object'], ['date_mfg','object'], ['hidden','boolean'], ['lot_number','string']];
          for(const p in product.lots[j]){
            let check_duplicate = false;
            if(p.indexOf('webapp_') === -1){
              for(const q in field_lot){
                if(p === field_lot[q][0]){
                  check_duplicate = true;
                  if(typeof product.lots[j][p] != field_lot[q][1]){
                    console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào product(lots)', p);
                    if(enable_return) return true;
                  }
                }
              }
            }
            if(!check_duplicate){
              console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào product(lots)', p);
              if(enable_return) return true;
            }              
          } 
          if(product.lots[j]['barcode'] != "") barcodes.push(product.lots[j]['barcode']);
          for(const p in field_lot){
            let check_duplicate = false;
            for(const q in product.lots[j]){
              if(field_lot[p][0] === q){
                check_duplicate = true;
              }
            }
            if(!check_duplicate){
              console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào product(lots)', field_lot[p][0]);
              if(enable_return) return true;
            }
          } 
        }
      }   
    }
    
    for(let i=0; i<barcodes.length-1; i++){        
      for(let j=i+1; j<barcodes.length; j++){          
        if(barcodes[i] === barcodes[j]) {
          console.log('Vui lòng kiểm tra, bị trùng barcode');
          if(enable_return) return true;
        }
      }
    }  
    return false;
}

export function checkCafe_addSubProduct_type1(id_product:string, subProduct:any){    
  let enable_return = true; 
  if(!id_product || id_product ==='') {
    console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào id_product');
    if(enable_return) return true;
  }
  let barcodes = new Array();
  let field_sub = [['name','string'], ['selling','boolean'], ['units','object'], ['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean']];

  for(const p in subProduct){
    let check_duplicate = false;
    for(const q in field_sub){
      if(p === field_sub[q][0]){
        check_duplicate = true;
        if(typeof subProduct[p] != field_sub[q][1]){
          console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào subProduct', p);
          if(enable_return) return true;
        }
      }
    }
    if(!check_duplicate){
      console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào subProduct', p);
      if(enable_return) return true;
    }              
  } 
  for(const p in field_sub){
    let check_duplicate = false;
    for(const q in subProduct){
      if(field_sub[p][0] === q){
        check_duplicate = true;
      }
    }
    if(!check_duplicate){
      console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào subProduct', p);
      if(enable_return) return true;
    }              
  } 
  if(subProduct.units){
    for(let j=0; j<subProduct.units.length; j++){
      let field_unit = [['barcode','string'], ['default','boolean'], ['price','number'], ['price2','number'], ['ratio','number'], 
                        ['unit','string']];
      for(const p in subProduct.units[j]){
        let check_duplicate = false;
        for(const q in field_unit){
          if(p === field_unit[q][0]){
            check_duplicate = true;
            if(typeof subProduct.units[j][p] != field_unit[q][1]){
              console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào subProduct(units)', p);
              if(enable_return) return true;
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào subProduct(units)', p);
          if(enable_return) return true;
        }                               
      } 
      if(subProduct.units[j]['barcode'] != "") barcodes.push(subProduct.units[j]['barcode']);    
      for(const p in field_unit){
        let check_duplicate = false;
        for(const q in subProduct.units[j]){
          if(field_unit[p][0] === q){
            check_duplicate = true;
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào subProduct(units)', p);
          if(enable_return) return true;
        }
      } 
    }
  }  
  return false;
}

export function checkCafe_addSubProduct_type3(id_product:string, subProduct:any){    
  let enable_return = true; 
  if(!id_product || id_product ==='') {
    console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào id_product');
    if(enable_return) return true;
  }
  let barcodes = new Array();
  let field_sub = [['manylot','boolean'], ['name','string'], ['selling','boolean'], ['units','object'], ['warning_number','number'], ['item_code','string'], ['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean']];
  if(subProduct.manylot){
    field_sub = [['manylot','boolean'], ['name','string'], ['selling','boolean'], ['units','object'], ['warning_number','number'], ['item_code','string'], ['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean'],
                ['days_exp_warning','number'], ['days_import_warning','number'], ['lots','object']];
  }else{
      for(const p in subProduct){
        let check_duplicate = false;
        for(const q in field_sub){
          if(p === field_sub[q][0]){
            check_duplicate = true;
            if(typeof subProduct[p] != field_sub[q][1]){
              console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào subProduct', p);
              if(enable_return) return true;
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào subProduct', p);
          if(enable_return) return true;
        }              
      } 
      for(const p in field_sub){
        let check_duplicate = false;
        for(const q in subProduct){
          if(field_sub[p][0] === q){
            check_duplicate = true;
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào subProduct', p);
          if(enable_return) return true;
        }              
      } 
      if(subProduct.units){
        for(let j=0; j<subProduct.units.length; j++){
          let field_unit = [['barcode','string'], ['default','boolean'], ['price','number'], ['price2','number'], ['price_import','number'], ['ratio','number'], 
                            ['unit','string']];
          for(const p in subProduct.units[j]){
            let check_duplicate = false;
            for(const q in field_unit){
              if(p === field_unit[q][0]){
                check_duplicate = true;
                if(typeof subProduct.units[j][p] != field_unit[q][1]){
                  console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào subProduct(units)', p);
                  if(enable_return) return true;
                }
              }
            }
            if(!check_duplicate){
              console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào subProduct(units)', p);
              if(enable_return) return true;
            }                               
          } 
          if(subProduct.units[j]['barcode'] != "") barcodes.push(subProduct.units[j]['barcode']);    
          for(const p in field_unit){
            let check_duplicate = false;
            for(const q in subProduct.units[j]){
              if(field_unit[p][0] === q){
                check_duplicate = true;
              }
            }
            if(!check_duplicate){
              console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào subProduct(units)', p);
              if(enable_return) return true;
            }
          } 
        }
      }
      if(subProduct.lots){
        for(let j=0; j<subProduct.lots.length; j++){
          let field_lot = [['barcode','string'], ['date_exp','object'], ['date_mfg','object'], ['hidden','boolean'], ['lot_number','string']];
          for(const p in subProduct.lots[j]){
            let check_duplicate = false;
            for(const q in field_lot){
              if(p === field_lot[q][0]){
                check_duplicate = true;
                if(typeof subProduct.lots[j][p] != field_lot[q][1]){
                  console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào subProduct(lots)', p);
                  if(enable_return) return true;
                }
              }
            }
            if(!check_duplicate){
              console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào subProduct(lots)', p);
              if(enable_return) return true;
            }                  
          } 
          if(subProduct.lots[j]['barcode'] != "") barcodes.push(subProduct.lots[j]['barcode']);
          for(const p in field_lot){
            let check_duplicate = false;
            for(const q in subProduct.lots[j]){
              if(field_lot[p][0] === q){
                check_duplicate = true;
              }
            }
            if(!check_duplicate){
              console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào subProduct(lots)', p);
              if(enable_return) return true;
            }
          } 
        }
      }
  }  
  return false;
}

export function checkCafe_updateSubProduct_type1(id_subproduct:string, value:any){    
  let enable_return = true; 
  if(!id_subproduct || id_subproduct ==='') {
    console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào id_subproduct');
    if(enable_return) return true;
  }

  let barcodes = new Array();  
  let field_sub = [['manylot','boolean'], ['name','string'], ['selling','boolean'], ['units','object'], ['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean']];
                     
  for(const p in value){
    let check_duplicate = false;
    for(const q in field_sub){
      if(p === field_sub[q][0]){
        check_duplicate = true;
        if(typeof value[p] != field_sub[q][1]){
          console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value', p);
          if(enable_return) return true;
        }
      }
    }
    if(!check_duplicate){
      console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value', p);
      if(enable_return) return true;
    }              
  } 
  
  if(value.units){
    for(let j=0; j<value.units.length; j++){
      let field_unit = [['barcode','string'], ['default','boolean'], ['price','number'], ['price2','number'], ['ratio','number'], 
                        ['unit','string']];
      for(const p in value.units[j]){
        let check_duplicate = false;
        for(const q in field_unit){
          if(p === field_unit[q][0]){
            check_duplicate = true;
            if(typeof value.units[j][p] != field_unit[q][1]){
              console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value(units)', p);
              if(enable_return) return true;
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value(units)', p);
          if(enable_return) return true;
        }                               
      } 
      if(value.units[j]['barcode'] != "") barcodes.push(value.units[j]['barcode']);    
      for(const p in field_unit){
        let check_duplicate = false;
        for(const q in value.units[j]){
          if(field_unit[p][0]===q){
            check_duplicate = true;           
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào value(units)', p);
          if(enable_return) return true;
        }                               
      } 
      
    }
  }
  return false;
}

export function checkCafe_updateSubProduct_type3(id_subproduct:string, value:any){    
  let enable_return = true; 
  if(!id_subproduct || id_subproduct ==='') {
    console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào id_subproduct');
    if(enable_return) return true;
  }

  let barcodes = new Array();  
  let field_sub = [['manylot','boolean'], ['name','string'], ['selling','boolean'], ['units','object'], ['warning_number','number'], ['item_code','string'], ['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean'],
                   ['days_exp_warning','number'], ['days_import_warning','number'], ['lots','object']];
  
  for(const p in value){
    let check_duplicate = false;
    for(const q in field_sub){
      if(p === field_sub[q][0]){
        check_duplicate = true;
        if(typeof value[p] != field_sub[q][1]){
          console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value', p);
          if(enable_return) return true;
        }
      }
    }
    if(!check_duplicate){
      console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value', p);
      if(enable_return) return true;
    }              
  } 
  
  if(value.units){
    for(let j=0; j<value.units.length; j++){
      let field_unit = [['barcode','string'], ['default','boolean'], ['price','number'], ['price2','number'], ['price_import','number'], ['ratio','number'], 
                        ['unit','string']];
      for(const p in value.units[j]){
        let check_duplicate = false;
        for(const q in field_unit){
          if(p === field_unit[q][0]){
            check_duplicate = true;
            if(typeof value.units[j][p] != field_unit[q][1]){
              console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value(units)', p);
              if(enable_return) return true;
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value(units)', p);
          if(enable_return) return true;
        }                               
      } 
      if(value.units[j]['barcode'] != "") barcodes.push(value.units[j]['barcode']);    
      for(const p in field_unit){
        let check_duplicate = false;
        for(const q in value.units[j]){
          if(field_unit[p][0]===q){
            check_duplicate = true;           
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào value(units)', p);
          if(enable_return) return true;
        }                               
      } 
      
    }
  }
  if(value.lots){
    for(let j=0; j<value.lots.length; j++){
      let field_lot = [['_id','string'], ['barcode','string'], ['date_exp','object'], ['date_mfg','object'], ['hidden','boolean'], ['lot_number','string']];
      for(const p in value.lots[j]){
        let check_duplicate = false;
        for(const q in field_lot){
          if(p === field_lot[q][0]){
            check_duplicate = true;
            if(typeof value.lots[j][p] != field_lot[q][1]){
              console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value(lots)', p);
              if(enable_return) return true;
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value(lots)', p);
          if(enable_return) return true;
        }                  
      } 
      if(value.lots[j]['barcode'] != "") barcodes.push(value.lots[j]['barcode']);      
      for(const p in field_lot){
        let check_duplicate = false;
        for(const q in value.lots[j]){
          if(field_lot[p][0] === q){
            check_duplicate = true;            
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào value(lots)', p);
          if(enable_return) return true;
        }                  
      } 

    }
  } 
  return false;
}

export function checkCafe_updateProduct_Type1(id_product:string, value:any){   
  let enable_return = true;  
  if(!id_product || id_product ==='') {
    console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào id_product');
    if(enable_return) return true;
  }
  let barcodes = new Array();  
  let field_main = [['vat_reduction','number'], ['id_category','string'], ['img','string'], ['manysize','boolean'],
                    ['name','string'], ['selling','boolean'], ['type','number'], ['units','object'], ['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean'],  
                    ['id_design_barcode', 'string'], ['id_design_barcode_lot', 'string'], ['number_column', 'number'], ['number_column_lot', 'number'], 
                    ['number_print', 'number'], ['number_print_lot', 'number']];//sau này sẽ group phần designs này lại
  
  for(const p in value){
    let check_duplicate = false;
    for(const q in field_main){
      if(p === field_main[q][0]){
        check_duplicate = true;
        if(typeof value[p] != field_main[q][1]){
          console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value', p);
          if(enable_return) return true;
        }
      }
    }
    if(!check_duplicate){      
      console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value', p);
      if(enable_return) return true;           
    }              
  } 
  
  if(value.units){
    //console.log('----value', value)
    for(let j=0; j<value.units.length; j++){
      let field_unit = [['barcode','string'], ['default','boolean'], ['price','number'], ['price2','number'], ['ratio','number'], 
                        ['unit','string']];
      for(const p in value.units[j]){
        let check_duplicate = false;
        for(const q in field_unit){
          if(p === field_unit[q][0]){
            check_duplicate = true;
            if(typeof value.units[j][p] != field_unit[q][1]){
              console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value(units)', p);
              if(enable_return) return true;
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value(units)', p);
          if(enable_return) return true;
        }                               
      } 
      if(value.units[j]['barcode'] != "") barcodes.push(value.units[j]['barcode']);   
      for(const p in field_unit){
        let check_duplicate = false;
        for(const q in value.units[j]){
          if(field_unit[p][0] === q){           
            check_duplicate = true;
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào value(units)', p);
          if(enable_return) return true;
        }
      }       
    }
  }
  return false;
}

export function checkCafe_updateProduct_Type3(id_product:string, value:any){   
  let enable_return = true;  
  if(!id_product || id_product ==='') {
    console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào id_product');
    if(enable_return) return true;
  }
  let barcodes = new Array();  
  let field_main = [['brand','string'], ['tax', 'number'], ['vat_reduction','number'], ['id_category','string'], ['img','string'], ['manylot','boolean'], ['manysize','boolean'],
                    ['name','string'], ['selling','boolean'], ['type','number'], ['units','object'], ['warning_number','number'], ['item_code','string'], ['days_exp_warning','number'],
                    ['days_import_warning','number'], ['lots','object'], ['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean'],
                    ['id_design_barcode', 'string'], ['id_design_barcode_lot', 'string'], ['number_column', 'number'], ['number_column_lot', 'number'], ['number_print', 'number'], ['number_print_lot', 'number']];//sau này sẽ group phần designs này lại
  
  for(const p in value){
    let check_duplicate = false;
    for(const q in field_main){
      if(p === field_main[q][0]){
        check_duplicate = true;
        if(typeof value[p] != field_main[q][1]){
          console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value', p);
          if(enable_return) return true;
        }
      }
    }
    if(!check_duplicate){      
      console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value', p);
      if(enable_return) return true;           
    }              
  } 
  
  if(value.units){
    //console.log('----value', value)
    for(let j=0; j<value.units.length; j++){
      let field_unit = [['barcode','string'], ['default','boolean'], ['price','number'], ['price2','number'], ['price_import','number'], ['ratio','number'], 
                        ['unit','string']];
      for(const p in value.units[j]){
        let check_duplicate = false;
        for(const q in field_unit){
          if(p === field_unit[q][0]){
            check_duplicate = true;
            if(typeof value.units[j][p] != field_unit[q][1]){
              console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value(units)', p);
              if(enable_return) return true;
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value(units)', p);
          if(enable_return) return true;
        }                               
      } 
      if(value.units[j]['barcode'] != "") barcodes.push(value.units[j]['barcode']);   
      for(const p in field_unit){
        let check_duplicate = false;
        for(const q in value.units[j]){
          if(field_unit[p][0] === q){           
            check_duplicate = true;
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào value(units)', p);
          if(enable_return) return true;
        }
      }       
    }
  }
  if(value.lots){
    for(let j=0; j<value.lots.length; j++){
      let field_lot = [['_id','string'], ['barcode','string'], ['date_exp','object'], ['date_mfg','object'], ['hidden','boolean'], ['lot_number','string']];
      for(const p in value.lots[j]){
        let check_duplicate = false;
        for(const q in field_lot){
          if(p === field_lot[q][0]){
            check_duplicate = true;
            if(typeof value.lots[j][p] != field_lot[q][1]){
              console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value(lots)', p);
              if(enable_return) return true;
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value(lots)', p);
          if(enable_return) return true;
        }                  
      } 
      if(value.lots[j]['barcode'] != "") barcodes.push(value.lots[j]['barcode']);    
      for(const p in field_lot){
        let check_duplicate = false;
        for(const q in value.lots[j]){
          if(field_lot[p][0] === q){
            check_duplicate = true;            
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào value(lots)', p);
          if(enable_return) return true;
        }                  
      }       
    }
  } 
  return false;
}

export function checkCafe_updateProduct_Type1_fw(id_product:string, value:any){  
  //console.log('--value', value); 
  let enable_return = true;  
  if(!id_product || id_product ==='') {
    console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào id_product');
    if(enable_return) return true;
  }
  let barcodes = new Array();  
  let field_main = [['vat_reduction','number'], ['id_category','string'], ['img','string'], ['manysize','boolean'],
                    ['name','string'], ['selling','boolean'], ['type','number'], ['units','object'],
                    ['quantity','number'], ['quantity_branch','object'],['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean'],                
                    ['id_design_barcode', 'string'], ['id_design_barcode_lot', 'string'], ['number_column', 'number'], ['number_column_lot', 'number'], ['number_print', 'number'], ['number_print_lot', 'number']];//sau này sẽ group phần designs này lại
  
  for(const p in value){
    let check_duplicate = false;
    for(const q in field_main){
      if(p === field_main[q][0]){
        check_duplicate = true;
        if(typeof value[p] != field_main[q][1]){
          console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value', p);
          if(enable_return) return true;
        }
      }
    }
    if(!check_duplicate){
      if(value[p]['inventory'] === undefined){
        console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value', p);
        if(enable_return) return true;
      }      
    }              
  } 
  
  if(value.units){
    //console.log('----value', value)
    for(let j=0; j<value.units.length; j++){
      let field_unit = [['barcode','string'], ['default','boolean'], ['price','number'], ['price2','number'], ['ratio','number'], 
                        ['unit','string']];
      for(const p in value.units[j]){
        let check_duplicate = false;
        for(const q in field_unit){
          if(p === field_unit[q][0]){
            check_duplicate = true;
            if(typeof value.units[j][p] != field_unit[q][1]){
              console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value(units)', p);
              if(enable_return) return true;
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value(units)', p);
          if(enable_return) return true;
        }                               
      } 
      if(value.units[j]['barcode'] != "") barcodes.push(value.units[j]['barcode']);   
      for(const p in field_unit){
        let check_duplicate = false;
        for(const q in value.units[j]){
          if(field_unit[p][0] === q){           
            check_duplicate = true;
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào value(units)', p);
          if(enable_return) return true;
        }
      }       
    }
  }
  return false;
}

export function checkCafe_updateProduct_Type3_fw(id_product:string, value:any){  
  //console.log('--value', value); 
  let enable_return = true;  
  if(!id_product || id_product ==='') {
    console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào id_product');
    if(enable_return) return true;
  }
  let barcodes = new Array();  
  let field_main = [['brand','string'], ['tax', 'number'], ['vat_reduction','number'], ['id_category','string'], ['img','string'], ['manylot','boolean'], ['manysize','boolean'],
                    ['name','string'], ['selling','boolean'], ['type','number'], ['units','object'], ['warning_number','number'], ['item_code','string'], ['days_exp_warning','number'], 
                    ['quantity','number'], ['quantity_branch','object'],['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean'],
                    ['days_import_warning','number'], ['lots','object'],
                    ['id_design_barcode', 'string'], ['id_design_barcode_lot', 'string'], ['number_column', 'number'], ['number_column_lot', 'number'], ['number_print', 'number'], ['number_print_lot', 'number']];//sau này sẽ group phần designs này lại
  
  for(const p in value){
    let check_duplicate = false;
    for(const q in field_main){
      if(p === field_main[q][0]){
        check_duplicate = true;
        if(typeof value[p] != field_main[q][1]){
          console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value', p);
          if(enable_return) return true;
        }
      }
    }
    if(!check_duplicate){
      if(value[p]['inventory'] === undefined){
        console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value', p);
        if(enable_return) return true;
      }      
    }              
  } 
  
  if(value.units){
    //console.log('----value', value)
    for(let j=0; j<value.units.length; j++){
      let field_unit = [['barcode','string'], ['default','boolean'], ['price','number'], ['price2','number'], ['price_import','number'], ['ratio','number'], 
                        ['unit','string']];
      for(const p in value.units[j]){
        let check_duplicate = false;
        for(const q in field_unit){
          if(p === field_unit[q][0]){
            check_duplicate = true;
            if(typeof value.units[j][p] != field_unit[q][1]){
              console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value(units)', p);
              if(enable_return) return true;
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value(units)', p);
          if(enable_return) return true;
        }                               
      } 
      if(value.units[j]['barcode'] != "") barcodes.push(value.units[j]['barcode']);   
      for(const p in field_unit){
        let check_duplicate = false;
        for(const q in value.units[j]){
          if(field_unit[p][0] === q){           
            check_duplicate = true;
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào value(units)', p);
          if(enable_return) return true;
        }
      }       
    }
  }
  if(value.lots){
    for(let j=0; j<value.lots.length; j++){
      let field_lot = [['_id','string'], ['barcode','string'], ['date_exp','object'], ['date_mfg','object'], ['hidden','boolean'], ['lot_number','string']];
      for(const p in value.lots[j]){
        let check_duplicate = false;
        for(const q in field_lot){
          if(p === field_lot[q][0]){
            check_duplicate = true;
            if((p === 'date_exp')||(p === 'date_mfg')){
              value.lots[j][p] = new Date(value.lots[j][p]);
            }
            if(typeof value.lots[j][p] != field_lot[q][1]){
              console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value(lots)', p);
              if(enable_return) return true;
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value(lots)', p);
          if(enable_return) return true;
        }                  
      } 
      if(value.lots[j]['barcode'] != "") barcodes.push(value.lots[j]['barcode']);    
      for(const p in field_lot){
        let check_duplicate = false;
        for(const q in value.lots[j]){
          if(field_lot[p][0] === q){
            check_duplicate = true;            
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào value(lots)', p);
          if(enable_return) return true;
        }                  
      }       
    }
  } 
  return false;
}

export function checkCafe_updateProduct_Type2(id_product:string, value:any){   
  let enable_return = true;  
  if(!id_product || id_product ==='') {
    console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào id_product');
    if(enable_return) return true;
  }
  let barcodes = new Array();  
  let field_main = [['brand','string'], ['tax', 'number'], ['vat_reduction','number'], ['id_category','string'], ['img','string'], ['manylot','boolean'], ['manysize','boolean'],
                    ['name','string'], ['selling','boolean'], ['type','number'], ['units','object'], ['warning_number','number'], ['item_code','string'], ['days_exp_warning','number'], 
                    ['days_import_warning','number'], ['lots','object'],['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean'],
                    ['id_design_barcode', 'string'], ['id_design_barcode_lot', 'string'], ['number_column', 'number'], ['number_column_lot', 'number'], ['number_print', 'number'], ['number_print_lot', 'number']];//sau này sẽ group phần designs này lại
  
  for(const p in value){
    let check_duplicate = false;
    for(const q in field_main){
      if(p === field_main[q][0]){
        check_duplicate = true;
        if(typeof value[p] != field_main[q][1]){
          console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value', p);
          if(enable_return) return true;
        }
      }
    }
    if(!check_duplicate){
      console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value', p);
      if(enable_return) return true;
    }              
  } 
  
  if(value.units){
    //console.log('----value', value)
    for(let j=0; j<value.units.length; j++){
      let field_unit = [['barcode','string'], ['default','boolean'], ['price','number'], ['price2','number'], ['ratio','number'], 
                        ['unit','string']];
      for(const p in value.units[j]){
        let check_duplicate = false;
        for(const q in field_unit){
          if(p === field_unit[q][0]){
            check_duplicate = true;
            if(typeof value.units[j][p] != field_unit[q][1]){
              console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value(units)', p);
              if(enable_return) return true;
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value(units)', p);
          if(enable_return) return true;
        }                               
      } 
      if(value.units[j]['barcode'] != "") barcodes.push(value.units[j]['barcode']);   
      for(const p in field_unit){
        let check_duplicate = false;
        for(const q in value.units[j]){
          if(field_unit[p][0] === q){           
            check_duplicate = true;
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào value(units)', p);
          if(enable_return) return true;
        }
      }       
    }
  }
  if(value.lots){
    for(let j=0; j<value.lots.length; j++){
      let field_lot = [['_id','string'], ['barcode','string'], ['date_exp','object'], ['date_mfg','object'], ['hidden','boolean'], ['lot_number','string']];
      for(const p in value.lots[j]){
        let check_duplicate = false;
        for(const q in field_lot){
          if(p === field_lot[q][0]){
            check_duplicate = true;
            if(typeof value.lots[j][p] != field_lot[q][1]){
              console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value(lots)', p);
              if(enable_return) return true;
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value(lots)', p);
          if(enable_return) return true;
        }                  
      } 
      if(value.lots[j]['barcode'] != "") barcodes.push(value.lots[j]['barcode']);    
      for(const p in field_lot){
        let check_duplicate = false;
        for(const q in value.lots[j]){
          if(field_lot[p][0] === q){
            check_duplicate = true;            
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào value(lots)', p);
          if(enable_return) return true;
        }                  
      }       
    }
  } 
  return false;
}
export function checkCafe_updateProduct_Type5(id_product:string, value:any){   
  let enable_return = true;  
  if(!id_product || id_product ==='') {
    console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào id_product');
    if(enable_return) return true;
  }
  let barcodes = new Array();  
  let field_main = [['brand','string'], ['tax', 'number'], ['vat_reduction','number'], ['id_category','string'], ['img','string'], ['manylot','boolean'], ['manysize','boolean'],
                    ['name','string'], ['selling','boolean'], ['type','number'], ['units','object'], ['warning_number','number'], ['item_code','string'], ['days_exp_warning','number'], 
                    ['days_import_warning','number'], ['lots','object'], ['describe','string'],['delete_hidden','boolean'], ['allow_sell','boolean'], ['allow_table_order','boolean'],
                    ['id_design_barcode', 'string'], ['id_design_barcode_lot', 'string'], ['number_column', 'number'], ['number_column_lot', 'number'], ['number_print', 'number'], ['number_print_lot', 'number']];//sau này sẽ group phần designs này lại
  
  for(const p in value){
    let check_duplicate = false;
    for(const q in field_main){
      if(p === field_main[q][0]){
        check_duplicate = true;
        if(typeof value[p] != field_main[q][1]){
          console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value', p);
          if(enable_return) return true;
        }
      }
    }
    if(!check_duplicate){
      console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value', p);
      if(enable_return) return true;
    }              
  } 
  
  if(value.units){    
    for(let j=0; j<value.units.length; j++){
      let field_unit = [['barcode','string'], ['default','boolean'], ['price','number'], ['ratio','number'], ['unit','string']];
      for(const p in value.units[j]){
        let check_duplicate = false;
        for(const q in field_unit){
          if(p === field_unit[q][0]){
            check_duplicate = true;
            if(typeof value.units[j][p] != field_unit[q][1]){
              console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value(units)', p);
              if(enable_return) return true;
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value(units)', p);
          if(enable_return) return true;
        }                               
      } 
      if(value.units[j]['barcode'] != "") barcodes.push(value.units[j]['barcode']);   
      for(const p in field_unit){
        let check_duplicate = false;
        for(const q in value.units[j]){
          if(field_unit[p][0] === q){            
            check_duplicate = true;
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào value(units)', p);
          if(enable_return) return true;
        }
      }       
    }
  }
  if(value.lots){
    for(let j=0; j<value.lots.length; j++){
      let field_lot = [['_id','string'], ['barcode','string'], ['date_exp','object'], ['date_mfg','object'], ['hidden','boolean'], ['lot_number','string']];
      for(const p in value.lots[j]){
        let check_duplicate = false;
        for(const q in field_lot){
          if(p === field_lot[q][0]){
            check_duplicate = true;
            if(typeof value.lots[j][p] != field_lot[q][1]){
              console.log('Vui lòng kiểm tra, kiểu dữ liệu trong tham số truyền vào value(lots)', p);
              if(enable_return) return true;
            }
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thừa trường trong tham số truyền vào value(lots)', p);
          if(enable_return) return true;
        }                  
      } 
      if(value.lots[j]['barcode'] != "") barcodes.push(value.lots[j]['barcode']);    
      for(const p in field_lot){
        let check_duplicate = false;
        for(const q in value.lots[j]){
          if(field_lot[p][0] === q){
            check_duplicate = true;            
          }
        }
        if(!check_duplicate){
          console.log('Vui lòng kiểm tra, thiếu trường trong tham số truyền vào value(lots)', p);
          if(enable_return) return true;
        }                  
      }       
    }
  } 
  return false;
}